module.exports = __webpack_public_path__ + "img/sandwich.54123e7b.svg";